
import {React, useState, useEffect, useRef} from "react"
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Table,
  TableContainer,
  Paper,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { ExpandMore,

 } from "@mui/icons-material";
import { useStyle } from "../../context/styleContext/styleContext";
import ReactGA from 'react-ga4';
import Seo from "../../components/Seo";


export default function AllReleases(){

  const { style } = useStyle();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [height, setHeight] = useState(window.innerHeight)
  useEffect(() => {
    function handleResize() {      
      setHeight(window.innerHeight)
  }  
    window.addEventListener('resize', handleResize)
  })

  const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);



  return (
    <>
<Seo
  title="All Releases | Parish Audio"
  description="Browse all music and audio releases from Parish Audio in one place."
  canonical="https://parishaudio.com/all-releases"
/>
    
    <div style={{width:'95%', margin:'auto', minHeight:height - 130}}>
        <Box sx={{width:'95%', maxWidth:'900px', margin:'auto', marginBottom:'30px'}}>
        <h1 ref={topContainer}>Available Downloads</h1>

        <h2 style={{marginTop:'20px'}}><a href ='/products/infinity-reverb'>Infinity Reverb</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            {/* <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac AU</strong></TableCell> */}
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.1</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InfinityReverb_1_0_1/Infinity Reverb 1.0.1 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InfinityReverb_1_0_1/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_1/Infinity Reverb 1.0.1 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>June 12, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Bug fix</TableCell>
            </TableRow>


            <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InfinityReverb_1_0_0/Infinity Reverb 1.0 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb 1.0 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>April 19, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>



      <h2 style={{marginTop:'20px'}}><a href ='/products/instagate'>InstaGate Noisegate</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            {/* <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac AU</strong></TableCell> */}
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.1</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InstaGate_1_0_1/Instagate Noisegate 1.0.1 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InstaGate_1_0_1/Instagate Noisegate.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InstaGate_1_0_1/InstaGate Noisegate 1.0.1 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>June 12, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Bug fix</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InstaGate_1_0_0/InstaGate Noisegate 1.0 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/InstaGate_1_0_0/InstaGate Noisegate.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InstaGate_1_0_0/InstaGate Noisegate 1.0 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>April 19, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>


      <h2 style={{marginTop:'20px'}}><a href ='/products/mk1-overdrive'>MK1 Overdrive</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            {/* <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}} ><strong>Mac AU</strong></TableCell> */}
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.1</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/MK1Overdrive_1_0_1/MK-1 Overdrive 1.0.1 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3//MK1Overdrive_1_0_1/MK-1 Overdrive.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3//MK1Overdrive_1_0_1/MK-1 Overdrive 1.0.1 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>June 12, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Bug fix</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/MK1Overdrive_1_0_0/MK-1 Overdrive 1.0 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/MK1Overdrive_1_0_0/MK-1 Overdrive.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/MK1Overdrive_1_0_0/MK-1 Overdrive 1.0 VST3 Installer.pkg' download>download</a></TableCell>
              {/* <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/InfinityReverb_1_0_0/Infinity Reverb.component' download='Infinity Reverb.component'>download</a></TableCell> */}
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>April 19, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>


      <h2 style={{marginTop:'20px'}}><a href ='/products/mk1-overdrive'>D1 Delay</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/D1Delay_1_0_0/D1 Delay v1.0.0 VST3 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/WindowsVST3/D1Delay_1_0_0/D1 Delay.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/MacVST3/D1Delay_1_0_0/D1 Delay v1.0.0 VST3 Installer.pkg' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>June 14, 2025</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>


      <h2 style={{marginTop:'20px'}}><a href ='/products/aurora'>Aurora</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Aurora/Windows/Aurora 1.0.0 Windows Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Aurora/Windows/Aurora.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Aurora/Mac/Aurora v1.0.0 VST3.pkg' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Apr 12, 2026</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>

      <h2 style={{marginTop:'20px'}}><a href ='/products/vocal-pro'>Vocal Pro</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Vocal Pro/Windows/Vocal Pro 1.0.0 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Vocal Pro/Windows/Vocal Pro 1.0.0.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/Vocal Pro/Mac/Vocal Pro v1.0.0 VST3.pkg' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Apr 15, 2026</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

        </TableBody>
      </Table>

      <h2 style={{marginTop:'20px'}}><a href ='/products/HE1-harmonic-enhancer'>HE1 Harmonic Enhancer</a></h2>
      <Table sx={{ backgroundColor:style.color1, color:style.color4, textAlign:'center',mt:1}} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Version</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Windows VST3</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Mac VST3 Installer</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Release Date</strong></TableCell>
            <TableCell sx={{p:1, fontSize:'1rem', color:'white', textAlign:'center'}}><strong>Notes</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.0</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Windows/HE1 Harmonic Enhancer Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Windows/HE1 Harmonic Enhancer.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Mac/HE1 Harmonic Enhancer v1.0.0 VST3.pkg' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Apr 13, 2026</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Initial Release</TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>1.0.1</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Windows/HE1 Harmonic Enhancer v1.0.1 Installer.exe' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Windows/HE1 Harmonic Enhancer 1.0.1.vst3' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}><a href='/HE1HarmonicEnhancer/Mac/HE1 Harmonic Enhancer v1.0.1 VST3.pkg' download>download</a></TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Apr 15, 2026</TableCell>
              <TableCell align="center" sx={{p:1, fontSize:'.9rem', color:style.color4}}>Fix issue with drawing</TableCell>
            </TableRow>

        </TableBody>
      </Table>

        </Box>

        
    </div>
    </>
  );
}

